export default __webpack_public_path__ + "static/banner_iphone-988ae3cb864f6b24b4fa4b384b46a3a5.webp";